// extracted by mini-css-extract-plugin
module.exports = {"w124ae9d":"w124ae9d","entrez-w124ae9d":"entrez-w124ae9d","fadeIn":"fadeIn","t1afyvh0":"t1afyvh0","sirpwu7":"sirpwu7","e1la1cd6":"e1la1cd6","snnn5ws":"snnn5ws"};